module.exports = __webpack_public_path__ + "static/media/sharing-constants.1f89c4e5.png";